(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('mall-detail', {
                url: '/:langcode/malls/:name/:id',
                templateUrl: 'app/malls/mall-detail.html',
                controller: 'MallDetailController',
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'malls');
                    }],

                    HasPremium: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "real-estate-package",
                            "location-package",
                            "eco-package",
                            'seller-lead-package',
                            "premium-package",
                            "premiumplus-package",
                            "pro-ee-package",
                            "flex-package",
                            "gold-package",
                            "terminal-flex-package",
                            "terminal-pro-package",
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package"
                        ]);
                    }],

                    HasLocation: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage(["location-package"]);
                    }],
                    mall: ["notifierSvc", "mallsAPI", "$translate", "$transition$", "$rootScope", "$timeout", "historyService", function (notifierSvc, mallsAPI, $translate, $transition$, $rootScope, $timeout, historyService) {
                        return mallsAPI.get({ id: $transition$.params().id }).$promise.then(function (result) {
                            historyService.set('mall', $transition$.params().id);
                            return result;
                        }, function () {
                            $translate('c_mall1').then(function (res) {
                                notifierSvc.show({ message: res, type: "info" });
                            });
                            $timeout(function () {
                                $rootScope.MetaTags.prerender.statusCode = 301;
                                window.redirected = "Location: " + $transition$.router.stateService.href("analysis.country.malls", { langcode: $transition$.params().langcode, country: "world" });
                                $rootScope.MetaTags.prerender.header = window.redirected;
                            }, 0);
                            $transition$.abort();
                            $transition$.router.stateService.go("analysis.country.malls", { langcode: $transition$.params().langcode, country: "world" });
                        });
                    }],

                    geo: ['geoApi', 'mall', function (geoApi, mall) {
                        if (mall && mall.Lat) {
                            var geoAp = geoApi.get({ lat: +mall.Lat, long: +mall.Lon, level: 3 });
                            return geoAp.$promise.then(function (resb) {
                                return resb;
                            });
                        }
                    }],

                    name: ['mall', function (mall) {
                        return mall ? mall.Title : "";
                    }],

                    description: ['mall', function (mall) {
                        return mall ? mall.Description : "";
                    }],

                    location: ['mall', function (mall) {
                        return mall ? mall.Location : "";
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('analysis_projects');
                        $translatePartialLoader.addPart('analysis_election');
                        $translatePartialLoader.addPart('analysis_value');
                        return $translate.refresh();
                    }]
                },
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    name: { type: 'any', raw: true },
                    id: { type: 'any', raw: true }
                },
                metaTags: {
                    title: '{{name}}',
                    description: '{{description}}',
                    properties: {
                        'og:image': ['mall', function (mall) {
                            return mall ? mall.Photo.replace('https://', 'http://') : "";
                        }],
                        'og:image:secure_url': ['mall', function (mall) {
                            return mall ? mall.Photo.replace('http://', 'https://') : "";
                        }],
                        'og:type': 'website'
                    }
                }
            });
    }]);

})();
